import React from "react";
import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

const functions = [
  "Co-opt members with knowledge and experience in the particular domain for academic transactions.",
  "Promote teaching, research and related activities at the University.",
  "Exercise general supervision over academic policies and programmes.",
  "Provide directions for research and improving academic standards.",
  "Propose allocation of funds for conducting research.",
  "Recommend fellowships, scholarships, exhibitions, medals and prizes.",
  "Recognize persons of eminence as research guides/co-guides as prescribed in the ordinance.",
  "Formulate, modify and revise schemes for faculties/schools/departments for Governing Body approval.",
];
const members = [
  [
    "Prof. (Dr) Anand Mahalwar",
    "Chairperson",
    "Hon’ble Vice Chancellor, ISBM University",
  ],
  ["Dr. N. Kumar Swamy", "Member", "Dean (Academics), ISBM University"],
  ["Dr. Subhashish Biswas", "Member", "Professor & DSW, ISBM University"],
  [
    "Dr. Ashwani Sahu",
    "Member",
    "Asst. Prof. & HOD, Faculty of Arts & Humanities",
  ],
  ["Dr. Poonam Verma", "Member", "Asst. Prof. & HOD, Faculty of Sciences"],
  [
    "Mr. Rohit Sinha",
    "Member",
    "Asst. Professor, School of Commerce & Management",
  ],
  [
    "Mr. Takeshwar Kaushik",
    "Member",
    "Asst. Professor & HOD (i/c), Faculty of Engineering & Technology",
  ],
  ["Mr. Govinda Sahu", "Member", "Asst. Professor, Department of IT"],
  [
    "Ms. Chhayangi Bala Mahamala",
    "Member",
    "Asst. Professor & HOD (i/c), Faculty of Law",
  ],
  [
    "Mr. Yugal Kishor Rajput",
    "Member",
    "Asst. Professor & HOD (i/c), Faculty of Health & Allied Science",
  ],
  [
    "Dr. Vimla Sona",
    "Member",
    "Asst. Professor & HOD (i/c), Faculty of Library & Information Science",
  ],
  ["Prof. A.K.Thakur", "Member", "Chancellor’s Nominee"],
  ["Dr. Ashok Kumar Mishra", "Member", "Chancellor’s Nominee"],
  ["Dr. R. K. Agrawal", "Member", "Chancellor’s Nominee"],
  [
    "Shri Munir Sayyad",
    "Member",
    "Nominee, Hon’ble Chancellor, ISBM University",
  ],
  [
    "Dr. Shilpi Srivastava",
    "Member",
    "Professor, Faculty of Sciences, Kalinga University",
  ],
  ["Dr. M. S. Mishra", "Member", "Principal, Maharaja Agrasen College, Raipur"],
  ["Dr. Barada Prasad Bhol", "Member Secretary", "Registrar, ISBM University"],
  [
    "Dr. Aruna Ranasinghe",
    "Member",
    "Prof. Faculty of Commerce & Management, ISBM University",
  ],
  ["Prof. John White", "Member", "Prof. Faculty of Law, ISBM University"],
];
export default function AcademicCouncil() {
  return (
    <>
      <MetaInfo param="" id="about" />
      <Header school="common" />
      <main>
        <section className="bg-navy pb-[150px] pt-[150px] text-white">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[.18em] text-gold">
              <span className="h-px w-12 bg-current" />
              Academic Governance
            </div>
            <h1 className="mt-7 font-serif text-[clamp(50px,6.5vw,92px)] leading-[.96]">
              Academic Council
              <span className="block text-gold">
                shaping academic standards.
              </span>
            </h1>
            <p className="mt-8 max-w-3xl text-lg leading-8 text-white/65">
              The Academic Council is the academic body of the University; it
              coordinates and exercises supervision over the policies and
              programmes of the University. The Vice-Chancellor of the
              University is the chairman of the council.
            </p>
          </div>
        </section>
        <section className="bg-white py-20 lg:py-28">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] gap-16 max-sm:w-[calc(100%-28px)]">
            <div>
              <Eyebrow>Academic Mandate</Eyebrow>
              <Title
                before="Teaching, Research"
                highlight="And Standards"
                after=""
                position="middle"
                theme="burgundy"
              />
            </div>
            <div className="grid gap-5 sm:grid-cols-4 mt-10">
              {functions.map((x, i) => (
                <article
                  key={x}
                  className="border-l-2 border-gold bg-[#F8FAFB] p-7"
                >
                  <span className="text-xs font-bold text-burgundy">
                    0{i + 1}
                  </span>
                  <p className="mt-5 leading-7 text-ink/65">{x}</p>
                </article>
              ))}
            </div>
          </div>
        </section>
        <section className="bg-[#F4E8EC] py-20 lg:py-28">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <Eyebrow>Council Composition</Eyebrow>
            <Title
              before="Academic Leadership"
              highlight="Across Disciplines"
              after=""
              position="middle"
              theme="burgundy"
            />
            <div className="mt-12 border-t border-burgundy/20">
              {members.map(([n, d, r], i) => (
                <div
                  key={n}
                  className="grid gap-4 border-b border-burgundy/20 py-6 md:grid-cols-[55px_.8fr_180px_1fr]"
                >
                  <span className="text-gold-dark">0{i + 1}</span>
                  <strong className="font-serif text-xl font-normal text-navy">
                    {n}
                  </strong>
                  <span className="text-xs font-bold uppercase text-burgundy">
                    {d}
                  </span>
                  <span className="text-sm text-ink/55">{r}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
